import { Operation } from '../../../__generated__/globalTypes'

import denyNotificationString from '../DenyNotification.graphql'

export type DenyNotificationData = {
  denyNotification: {
    success: boolean
  }
}

export type DenyNotificationVariables = {
  id: string
}

export type DenyNotification = Operation<
  DenyNotificationData,
  DenyNotificationVariables
>

export const DenyNotification = ({
  id,
}: DenyNotificationVariables): DenyNotification => ({
  query: denyNotificationString,
  variables: {
    id,
  },
})
